import React from 'react';
//import './Numput.css';
import './Radioput.css';

class Radioput extends React.Component {

  /* you have these props, which access to
  this.props.field, // { name, value, onChange, onBlur }
  this.props.form   // { touched, errors, values, setXXXX, handleXXXX, dirty, isValid, status, ...etc }.
   */
  constructor(props) {
    super(props);
  }


  handleClick = event => {
    this.props.form.setFieldValue(this.props.field.name, this.props.field.value);
  }




  render() {
    return (
      <div className="radioput-widget">
        <label>
          <input type="submit" 
            className="input-radioput" 
            name={this.props.field.name} 
            onClick={this.handleClick} 
            style={{visibility:"hidden",height:"0"}}/>
          {this.props.labelText}
          <span className={this.props.iconClass1}></span>
        </label>
      </div>
    );
  }
}

export default Radioput;